const XSmall = () => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

interface DillTagProps {
  label: string;
  onRemove?: () => void;
  isLoading?: boolean;
}

export const DillTag = ({ label, onRemove, isLoading }: DillTagProps) => (
  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-blue-50 border border-blue-200 text-[11px] font-medium text-blue-700">
    {label}
    {onRemove && (
      <button
        onClick={onRemove}
        disabled={isLoading}
        className="text-blue-400 hover:text-blue-700 cursor-pointer bg-transparent border-none leading-none disabled:opacity-40 disabled:cursor-not-allowed">
        {isLoading ? (
          <svg
            width={10}
            height={10}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            className="animate-spin">
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          <XSmall />
        )}
      </button>
    )}
  </span>
);
